import { SIGN_INTO_IDM, REFRESH_IDM_TOKEN, GET_ALL_PERMISSIONS } from './actions'
import RefreshToken from '../auth/RefreshToken'
import { refreshIDMToken } from '@/api'
import store from '@/store'

const refreshCall = function () {
  return refreshIDMToken().then(resp => {
    resp.expires = resp.expires_in
    return resp
  })
}

const onRefreshToken = function (resp) {
  store.dispatch(REFRESH_IDM_TOKEN, resp)
}

const mutations = {
  [SIGN_INTO_IDM](state, auth) {
    console.log(auth)
    state.token = auth.access_token
    state.expires = auth.expires_in
    state.refreshToken = auth.refresh_token
    state.loggedIn = true
    let expiresAt = new Date().getTime() + state.expires * 1000
    state.refreshInterval = RefreshToken({
      expires: expiresAt,
      refreshCall,
      intervalTime: 30,
      timeOffsetToReset: 190,
      onAfterRefreshCall: onRefreshToken,
    })
  },
  [REFRESH_IDM_TOKEN](state, refreshInfo) {
    state.expires = refreshInfo.expires_in
    state.refreshToken = refreshInfo.refresh_token
    state.token = refreshInfo.access_token
  },
  [GET_ALL_PERMISSIONS](state, permissions) {
    state.allPermissions = permissions
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/store/modules/idmAuth/mutations.js